import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeContext } from '../../contexts/ThemeContext';
import './Footer.css';

function Footer() {
    const { theme } = useContext(ThemeContext);

    // ইনলাইন স্টাইল অবজেক্ট
    const styles = {
        footer: { backgroundColor: theme.secondary },
        text: { color: theme.tertiary },
        linkContainer: { 
            color: theme.primary, 
            margin: '0 0.5rem' 
        },
        link: {
            color: theme.primary,
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            font: 'inherit',
            cursor: 'pointer',
            fontWeight: 'bold'
        }
    };

    return (
        <footer className="footer" style={styles.footer}>
            <p style={styles.text}>
                Copyright &copy; 2019 - {new Date().getFullYear()}
                <span style={styles.linkContainer}>
                    {/* button ট্যাগ বাদ দিয়ে সরাসরি NavLink-কে বাটন লুক দেওয়া হয়েছে */}
                    <NavLink to='/' style={styles.link}>
                        CryptoMehedi
                    </NavLink>
                </span>
                || All Rights Reserved
            </p>
        </footer>
    );
}

export default Footer;